import { RouteConfig } from "QuorumGrassroots/framework/helpers/RouteRegistry"
import { VoterInformationPage } from "./VoterInformationPage"

export const voterInformationRoutes: RouteConfig[] = [
    {
        path: "/campaign/:id/voter-information",
        component: VoterInformationPage,
        requiresLogin: true,
        pageTitle: "Voter Information",
        key: "campaign-voter-information",
    },
]
